import { MouseEvent } from 'react'

const preventPropagationForPost = (evt: MouseEvent<HTMLDivElement>) => {
  const el = evt.target as HTMLElement

  const isButton = el.tagName === 'BUTTON'

  // post links are SPAN wrapped in A tag
  const isLink = el.tagName === 'A' || el.tagName === 'SPAN'

  const canSkip = el.getAttribute('data-skip') === 'true'

  const preventDefault = el.getAttribute('data-prevent') === 'true'

  if ((isLink || isButton) && !canSkip) {
    evt.stopPropagation()
    preventDefault && evt.preventDefault()
  }
}

export default preventPropagationForPost
